import { SET_RECURRING_TASKS, REMOVE_RECURRING_TASK, UPDATE_TASK_FREQUENCY} from "../constants/recurringTasks"

const initialValue = {
    recurringTasks: {}
};

export default (state = initialValue, action) => {
    const { type } = action;
    switch (type) {
        case SET_RECURRING_TASKS: {
            const { recurringTasks } = action;
            return {
                ...state,
                recurringTasks
            };
        }
        case REMOVE_RECURRING_TASK: {
            const { taskId } = action;
            const { recurringTasks } = state;
            delete recurringTasks[taskId];
            return {
                ...state,
                recurringTasks
            };
        }
        case UPDATE_TASK_FREQUENCY: {
            const { taskId, frequency } = action;
            const { recurringTasks } = state;
            const task = recurringTasks.find(task => task.taskId === taskId);
            const newRecurringTasks = [...recurringTasks];
            newRecurringTasks.splice(newRecurringTasks.indexOf(task), 1);
            const newTask = {
                ...task,
                frequency: {
                    ...task.frequency,
                    ...frequency,
                    startIntervalOnCompletion: frequency.startIntervalOnCompletion ?? undefined
                }
            };
            newRecurringTasks.push(newTask);

            return {
                ...state,
                recurringTasks: newRecurringTasks
            };
        }
        default:
            return state
    }
}